/* RESPONSIBLE TEAM: team-integration-apps */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  buildURL() {
    return 'ember/salesforce_integrations/section_data';
  },
});
